import React from 'react';
import styled from 'styled-components';
import { useFeatureFlag } from '@sparknz/feature-flags';
import { useContent } from '@sparknz/journeys-common';
import { Box, QuickLinkCard } from '@sparknz/spark-pattern-library';
import { LinkRegion } from '@sparknz/tracking';

import { environmentVariables } from 'shared/utils/environment.utils';
import { useProductDetails } from '../../../../provider';
import { ProductDetailsActionTypes } from '../../../../reducer/productDetails.reducer';
import {
  QuickLinksCardListData,
  TradeInLayerStatus,
} from '../../../../typings';

const CardLink = styled.a`
  text-decoration: none;
  color: inherit;
  font-weight: inherit;
  font-size: inherit;
`;

const TradeInContainer = styled(Box)`
  max-width: 360px;
  position: relative;
`;

const TradeInSection: React.FC = () => {
  const { dispatch } = useProductDetails();
  const { data: quickLinksCardList } = useContent<QuickLinksCardListData>({
    apiBaseUrl: environmentVariables.apiURL,
    contentId: 'trade-in',
    modelId: 'quicklink-card-model',
    persistedQuery: 'quicklinkcard-model-list',
    variation: 'pdp-tradein',
    format: 'html',
  });
  const { value: shouldShowTradeInLayer } = useFeatureFlag(
    'release-pdp-trade-in-action-layer',
  );

  const quickLinksCardListItems =
    quickLinksCardList?.data?.quicklinksCardModelList?.items;

  if (!quickLinksCardListItems?.length) return null;

  return (
    <TradeInContainer mb="s4">
      {quickLinksCardListItems.map((quickLinksCardListItem) => {
        if (!quickLinksCardList) return null;
        const {
          title,
          description,
          linkLabel,
          linkUrl,
          target,
          imagePath,
          _path: quickLinksCardPath,
        } = quickLinksCardListItem;
        return shouldShowTradeInLayer ? (
          <Box
            key={linkUrl}
            onClick={() =>
              dispatch({
                type: ProductDetailsActionTypes.SetTradeInLayer,
                tradeInLayerStatus: TradeInLayerStatus.Open,
              })
            }
          >
            <QuickLinkCard
              title={title}
              description={description}
              icon={imagePath?._path}
              ctaTitle={linkLabel}
            />
          </Box>
        ) : (
          <LinkRegion key={linkUrl} regionId="tradeInAndSave">
            <CardLink href={linkUrl} target={target} key={quickLinksCardPath}>
              <QuickLinkCard
                title={title}
                description={description}
                icon={imagePath?._path}
                ctaTitle={linkLabel}
              />
            </CardLink>
          </LinkRegion>
        );
      })}
    </TradeInContainer>
  );
};

export default TradeInSection;
